import {
  GET_DATA_MANAJEMEN,
  GET_KATEGORI_MANAJEMEN,
  SET_LOADING_DATA_MANAJEMEN,
  SET_LOADING_KATEGORI_MANAJEMEN,
  SET_PAGINATION_DATA_MANAJEMEN,
  SET_PAGINATION_KATEGORI_MANAJEMEN,
} from '../constant';

const initialState = {
  kategori: [],
  loadingKategori: false,
  kategoriPagination: 0,
  totalKategori: 0,
  data: [],
  loadingData: false,
  dataPagination: 0,
  totalData: 0,
};

const manajemenPerusahaanReducer = function (state = initialState, action) {
  switch (action.type) {
    case SET_LOADING_KATEGORI_MANAJEMEN: {
      return {
        ...state,
        loadingKategori: action?.payload,
      };
    }
    case SET_PAGINATION_KATEGORI_MANAJEMEN: {
      return {
        ...state,
        kategoriPagination: action?.payload,
      };
    }
    case GET_KATEGORI_MANAJEMEN: {
      return {
        ...state,
        kategori: action?.payload?.data || [],
        totalKategori: action?.payload?.total,
        loadingKategori: false,
      };
    }
    case SET_LOADING_DATA_MANAJEMEN: {
      return {
        ...state,
        loadingData: action?.payload,
      };
    }
    case SET_PAGINATION_DATA_MANAJEMEN: {
      return {
        ...state,
        dataPagination: action?.payload,
      };
    }
    case GET_DATA_MANAJEMEN: {
      return {
        ...state,
        data: action?.payload?.data || [],
        totalData: action?.payload?.total,
        loadingData: false,
      };
    }
    default: {
      return state;
    }
  }
};

export default manajemenPerusahaanReducer;
